import React from "react";
import App from "./App.tsx";
import "./styles/index.css";
import ReactDOM from "react-dom/client";
// import { initSentry } from "./sentry.config.ts";
import { HelmetProvider } from "react-helmet-async";
import './tracing.ts';

// initSentry();
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
